import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import Select from "react-select";

import { useGetDirectoryUsersQuery } from "@/api/users-admin";
import { SelectComponents } from "./SelectUsersComponents";

interface Props {
  isReadOnly: boolean;
}
export const SelectUsers: React.FC<Props> = ({ isReadOnly }) => {
  const { control } = useFormContext();

  const userQuery = useGetDirectoryUsersQuery();
  if (userQuery.isLoading) {
    return null;
  }

  if (userQuery.isError) {
    return <div>Error loading users</div>;
  }

  return (
    <Controller
      name="users"
      control={control}
      render={({ field }) => (
        <Select
          {...field}
          isDisabled={isReadOnly}
          styles={{
            input: base => ({
              ...base,
              "input:focus": {
                boxShadow: "none",
              },
            }),
            clearIndicator: base => ({
              ...base,
              display: "none",
            }),
            valueContainer: provided => ({ ...provided, display: "flex" }),
          }}
          filterOption={(option, inputValue) =>
            [
              option.data?.name?.toLowerCase(),
              option.data?.surname?.toLowerCase(),
              option.data?.email?.toLowerCase(),
            ].some(label => label && label.includes(inputValue.toLowerCase()))
          }
          defaultValue={[]}
          placeholder="Select user to share"
          isSearchable
          isClearable
          isMulti
          maxMenuHeight={180}
          options={
            userQuery.data?.map(user => ({
              ...user,
              value: user.id,
            })) ?? []
          }
          components={SelectComponents}
          noOptionsMessage={noOptionMessage}
        />
      )}
    />
  );
};

const noOptionMessage = () => "No data";
